///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EngineProcessTypeEnum, ProjectDTO } from '../../../generated/shared-types.model';

@Injectable({
    providedIn: 'root'
})
export class GtthProjectStateService {
    private project: ProjectDTO;
    private lockedBy: string;
    private readonly lockChanged: BehaviorSubject<string>;

    constructor() {
        this.lockChanged = new BehaviorSubject<string>(undefined);
    }

    setProject(value: ProjectDTO) {
        this.project = value;
    }

    clearProject() {
        this.project = undefined;
    }

    getProject(): ProjectDTO {
        return this.project;
    }

    getProjectId(): number {
        return this.project ? this.project.id : undefined;
    }

    projectIsOpened(): boolean {
        return !!this.project;
    }

    isBugReport(): boolean {
        return this?.project?.bugReport;
    }

    isBomConfigProject(): boolean {
        return this?.project?.engineType === EngineProcessTypeEnum.BOM_CONFIGURATOR;
    }

    isPotentiallyCorruptedProject(): boolean {
        return this?.project?.engineType === EngineProcessTypeEnum.RINGDES_V_1211;
    }

    isAreaPlannerProject(): boolean {
        return this?.project?.engineType === EngineProcessTypeEnum.AREA_PLANNER;
    }

    isInterchangeExportSupported(): boolean {
        return (
            this.projectIsOpened() &&
            !this.isBomConfigProject() &&
            !this.isBugReport() &&
            !this.isPotentiallyCorruptedProject() &&
            !this.isAreaPlannerProject()
        );
    }

    subscribeToLockChanges(): Observable<string> {
        return this.lockChanged.asObservable();
    }

    projectLocked(login: string): void {
        this.lockedBy = login;
        this.lockChanged.next(this.lockedBy);
    }

    clearProjectLocked() {
        this.lockedBy = undefined;
        this.lockChanged.next(this.lockedBy);
    }

    getProjectLockedBy(): string {
        return this.lockedBy;
    }
}
